import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const Container = styled.div`
    min-width: 0;
`;

export const Message = styled.div`
    padding: 24px;
    color: ${colors.textSecondary};
`;
